import React, { useEffect, useState } from "react";
import { Chart } from "react-google-charts";
import cdpService from "../../../apiService/cdp.service";
import Loader from "../../Global/Loader";

const AgeDemographicsChart = ({ filters = {} }) => {
  const [chartData, setChartData] = useState([
    ["Age Group", "Total Users", { role: "style" }],
  ]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchData();
  }, [filters]); // Fetch data when filters change

  const fetchData = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await cdpService.getAgeGroupChart(filters || {});

      if (response.data.success) {
        const { ageGroupData } = response.data.data;

        const formattedData = [
          ["Age Group", "Total Users", { role: "style" }],
          ...ageGroupData.map((group) => [
            group.age_group,
            group.total > 0 ? group.total : 0.1,
            group.color_code || "#888888", // Default color if missing
          ]),
        ];

        setChartData(formattedData);
      } else {
        throw new Error("Failed to fetch data");
      }
    } catch (error) {
      setError("Error fetching age demographics data");
    } finally {
      setLoading(false);
    }
  };

  const options = {
    chartArea: {
      left: 80,
      right: 30,
      bottom: 50,
      top: 30,
      width: "80%",
      height: "80%",
    },
    legend: "none",
    vAxis: {
      title: "Total Users",
      logScale: true
    },
    hAxis: {
      title: "Age Group",
    },
  };

  if (loading) return <Loader/>;
  if (error) return <p className="text-red-500">{error}</p>;

  return (
    <Chart
      chartType="ColumnChart"
      width="100%"
      height="300px"
      data={chartData}
      options={options}
    />
  );
};

export default AgeDemographicsChart;
